import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionItemProps {
  id: string;
  isOpen: boolean;
  onToggle: () => void;
  header: React.ReactNode;
  children: React.ReactNode;
}

/** Light FAQ row: white card, gold chevron. */
export function AccordionItem({
  id,
  isOpen,
  onToggle,
  header,
  children
}: AccordionItemProps) {
  return <li className="rounded-xl border border-line bg-white" data-id="element-17" data-mp="o1t1rhfojyry">
      <h3 data-id="element-18" data-mp="3mmkj07m0ursp">
        <button type="button" onClick={onToggle} aria-expanded={isOpen} aria-controls={`${id}-panel`} className="flex w-full items-center gap-4 rounded-xl px-5 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold-text" data-id="element-19" data-mp="3mn2oluukqida">
          <span className="min-w-0 flex-1" data-id="element-20" data-mp="562x1mgd4oad">{header}</span>
          <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-text transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} strokeWidth={2.25} aria-hidden="true" data-id="element-21" data-mp="33v1h643qhjs9" />
        </button>
      </h3>
      <div id={`${id}-panel`} className={`grid transition-[grid-template-rows,opacity] duration-200 ease-out ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-22" data-mp="2469e6bkkum8f">
        <div className="overflow-hidden" data-id="element-23" data-mp="1ufwvkowbp34x">
          <div className="border-t border-line px-5 py-4" data-id="element-24" data-mp="1uelsysem61fe">{children}</div>
        </div>
      </div>
    </li>;
}